import React from "react";
import { FiSend, FiMessageCircle, FiBriefcase, FiMapPin, FiUsers } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import Heading from "../../reusable/Heading";
import ContactForm from "./Form";
import { sideHeaderElements } from "../../../data/sideHeader";
import { MdOutlineMailOutline, MdPhone } from "react-icons/md";
import { contact } from "../../../data/contact";
import css from "./form.module.css";
import useScrollReveal from "../../../hooks/useScrollReveal";

const trustPoints = [
  { icon: <FiBriefcase />, text: "Full-stack web and mobile delivery" },
  { icon: <FiUsers />, text: "Practical AI integration experience" },
  { icon: <FiMapPin />, text: "Based in Italy · open to remote teams" },
];

const Contact = () => {
  const headingRef = useScrollReveal();
  const formRef = useScrollReveal();
  const infoRef = useScrollReveal();

  return (
    <div className="container px-lg-5" style={{ paddingBottom: "7%" }}>
      <div ref={headingRef} className="reveal">
        <Heading icon={<FiSend />} headingTitle="Let’s Work Together" />
      </div>

      <div className="row gy-5">
        {/* Left: Form */}
        <div className="col-lg-7">
          <div ref={formRef} className="reveal reveal-delay-1">
            <div className={css.formCard}>
              <h3 className={css.formTitle}>Have a role that needs broad product ownership?</h3>
              <p className={css.formSubtitle}>
                If you need a developer who can contribute across frontend,
                backend, mobile, and AI, send the role or project context. I’ll
                respond with a focused conversation about fit and next steps.
              </p>
              <ContactForm />
            </div>
          </div>
        </div>

        {/* Right: Info */}
        <div className="col-lg-5">
          <div ref={infoRef} className="reveal reveal-delay-2">
            {/* WhatsApp Card */}
            <div className={css.infoCard}>
              <div className={css.whatsappHeader}>
                <FaWhatsapp className={css.whatsappIcon} />
                <div>
                  <h4 className={css.whatsappTitle}>Prefer a quick introduction?</h4>
                  <p className={css.whatsappText}>
                    Send the role, challenge, or product goal directly on WhatsApp.
                  </p>
                </div>
              </div>
              <a
                href="https://wa.me/393522947771?text=Hi%20Abdellah,%20I%20would%20like%20to%20discuss%20a%20developer%20opportunity."
                target="_blank"
                rel="noopener noreferrer"
                className={css.whatsappBtn}
              >
                <FiMessageCircle />
                <span>Start a conversation</span>
              </a>
            </div>

            {/* Trust Points */}
            <div className={css.trustList}>
              {trustPoints.map((point, i) => (
                <div key={i} className={css.trustItem}>
                  <span className={css.trustIcon}>{point.icon}</span>
                  <span className={css.trustText}>{point.text}</span>
                </div>
              ))}
            </div>

            {/* Contact Details */}
            <div className={css.contactDetails}>
              <div className={css.contactItem}>
                <MdPhone className={css.contactIcon} />
                <div>
                  <span className={css.contactLabel}>Phone</span>
                  <span className={css.contactValue}>{contact.phoneNumber}</span>
                </div>
              </div>
              <div className={css.contactItem}>
                <MdOutlineMailOutline className={css.contactIcon} />
                <div>
                  <span className={css.contactLabel}>Email</span>
                  <span className={css.contactValue}>{contact.email}</span>
                </div>
              </div>
            </div>

            {/* Social */}
            <div className={css.socialWrap}>
              <span className={css.socialLabel}>Connect</span>
              <div className={css.socialRow}>
                {sideHeaderElements[2].socialLinks.map((element, i) => (
                  <a
                    key={i}
                    href={element.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.socialLink}
                    aria-label={`Social link ${i + 1}`}
                  >
                    {element.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
